// ENTITY fr.gestionpial.pial.dto.ScoringDetailDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class ScoringDetailDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.ScoringDetailDTO';

  preferencePoints: number | null = 0;
  continuitePoints: number | null = 0;
  ecoleInterditePoints: number | null = 0;
  ecolePrioritairePoints: number | null = 0;
  ulisPrioritaire: boolean | null = false;
  reserve: boolean | null = false;
  totalScore: number | null = 0;
  explication: string | null = '';

  constructor(init?:Partial<ScoringDetailDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.ScoringDetailDTO'] = ScoringDetailDTO;

fields['fr.gestionpial.pial.dto.ScoringDetailDTO']  = {
    preferencePoints: 'java.lang.Integer',
    continuitePoints: 'java.lang.Integer',
    ecoleInterditePoints: 'java.lang.Integer',
    ecolePrioritairePoints: 'java.lang.Integer',
    ulisPrioritaire: 'java.lang.Boolean',
    reserve: 'java.lang.Boolean',
    totalScore: 'java.lang.Integer',
    explication: 'java.lang.String'
};
